import http from "@/settings/apiSettings"

class PORTAL_AprobariService {
  getPending(): Promise<any> {
    return http.clientPortalHR.get("/portal/aprobari-pending", {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  aprobare(id: string, tipCerere: string, observatie?: string): Promise<any> {
    return http.clientPortalHR.post(`/portal/aprobari/${id}/aprobare`, { TipCerere: tipCerere, Observatie: observatie }, {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }

  respingere(id: string, tipCerere: string, observatie?: string): Promise<any> {
    return http.clientPortalHR.post(`/portal/aprobari/${id}/respingere`, { TipCerere: tipCerere, Observatie: observatie }, {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }
}

export default new PORTAL_AprobariService();
